import { FC } from 'react'
import { useSelector } from 'react-redux'
import { IPages } from '../../shared/types/IPages'
import { selectActivePage } from './applicationSlice'
import QueuedArticles from './components/QueuedArticles'
import SearchArticles from './components/SearchArticles'
import TrendingArticles from './components/TrendingArticles'

const Application: FC = () => {
    const activePage = useSelector(selectActivePage)

    switch (activePage) {
        case IPages.ARTICLES:
            return <TrendingArticles />
        case IPages.SEARCH:
            return <SearchArticles />
        case IPages.QUEUE:
            return <QueuedArticles />
        default:
            return null
    }
}

export default Application
